<template>
  <div class="product">
    <div class="product-box">
      <div class="product-content">
        <div class="product-content-left">
          <div class="product-content-one">移动外业 \ 一键上传\ 一键生成</div>
          <div class="product-content-two">专为评估公司量身打造</div>
          <div class="product-content-three">评估端</div>
          <div
            class="product-content-four product-test"
            style=" margin-top: 30px;"
          >专为评估公司量身打造，广泛适应各地不同的评估业务根据实际项目情</div>
          <div class="product-content-four">况可自定义配置模板 iPad采集数据可一键上传至系统自动计算和批量</div>
          <div class="product-content-four">生成相关报表，避免重复作业和人工录入错误，大幅提高业务效率</div>
          <div class="product-btn" @click="toLogin">点击登录</div>
        </div>
        <div class="product-content-right">
          <img src="../assets/img/pinggu-0111.png" />
        </div>
      </div>
    </div>
    <div class="product-content-box">
      <div class="product-one">
        <div class="product-one-left" id="wrapper-text">
          <div class="text-one">移动外业设备查勘</div>
          <div
            class="text-two"
          >使用iPad录入数据并支持无网录入，后续可一键上传。查勘过程中可通过蓝牙功能将测量自动传输至iPad，避免人工录入数据，单户查勘完成后可使用打印机实现现场快速打印查勘结果，供被征收人查阅，针对部分地区要求现场签名或按手印，支持接入便携式A4打印机直接打印出A4纸质版查勘表</div>
        </div>
        <div class="product-one-right" id="wrapper-img">
          <img src="../assets/img/ipad.png" />
        </div>
      </div>
      <div class="product-two">
        <div class="product-two-left" id="wrapper-img1">
          <img src="../assets/img/pinggu-03.png" />
        </div>
        <div class="product-two-right" id="wrapper-text1">
          <div class="text-one">内业一键生成报表</div>
          <div
            class="text-two"
          >录入数据确认无误后，即可一键自动生成查勘表/测算表/分户报告/项目汇总表等报表，大幅降低数据录入失误或人为计算出错等问题，成千上百的大型征收评估项目也可迅速完成，节约人力成本。</div>
        </div>
      </div>
      <div class="product-three">
        <div class="product-three-left" id="wrapper-text2">
          <div class="text-one">各类模板自定义配置</div>
          <div
            class="text-two"
          >为广泛适应各地政策，评估端可根据全国各地不同的征收政策制定适应当地情况的模板及报表，并且可随时更改相关标准、参数或调整样式，实现各地差异化配置。</div>
        </div>
        <div class="product-three-right" id="wrapper-img2">
          <img src="../assets/img/pinggu-04.png" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    var x = document.getElementById('wrapper-img');
    x.setAttribute(
      'class',
      ' animate__animated animate__fadeInRight product-one-right'
    );
    var y = document.getElementById('wrapper-text');
    y.setAttribute(
      'class',
      ' animate__animated animate__fadeInLeft product-one-left'
    );
    var x1 = document.getElementById('wrapper-img1');
    x1.setAttribute(
      'class',
      ' animate__animated animate__fadeInLeft product-two-left'
    );
    var y1 = document.getElementById('wrapper-text1');
    y1.setAttribute(
      'class',
      ' animate__animated animate__fadeInRight product-two-right'
    );
    var x2 = document.getElementById('wrapper-img2');
    x2.setAttribute(
      'class',
      ' animate__animated animate__fadeInRight product-three-right'
    );
    var y2 = document.getElementById('wrapper-text2');
    y2.setAttribute(
      'class',
      ' animate__animated animate__fadeInLeft product-three-left'
    );
  },
  methods: {
    toLogin() {
      window.open('https://ev.yunzhengshou.com/login');
    }
  }
};
</script>
<style>
.product {
  width: 100%;
}
.product-box {
  display: flex;
  width: 100%;
  height: 650px;
  background: url('../assets/img/blue.png') no-repeat center;
  background-size: 100% 650px;
  overflow: hidden;
}
.product-content {
  display: flex;
  width: 1500px;
  height: 650px;
  margin: auto;
  overflow: hidden;
}
.product-content-left {
  margin-top: 70px;
  margin-left: 30px;
  width: 50%;
}
.product-content-one {
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 24px;
  color: #ffffff;
}
.product-content-two {
  font-family: '微软雅黑 Bold', '微软雅黑';
  font-weight: 700;
  font-style: normal;
  font-size: 60px;
  color: #ffffff;
  margin-top: 34px;
}
.product-content-three {
  margin-top: 20px;
  font-family: '微软雅黑 Bold', '微软雅黑';
  font-weight: 700;
  font-style: normal;
  font-size: 72px;
  color: #ffffff;
}
.product-content-four {
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 20px;
  color: #ffffff;
  line-height: 40px;
}
.product-btn {
  width: 110px;
  height: 40px;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 10px;
  border: 1px solid rgba(0, 189, 183, 1);
  text-align: center;
  line-height: 40px;
  color: rgba(0, 189, 183, 1);
  cursor: pointer;
  margin-top: 42px;
}
.product-btn:hover {
  color: rgb(41, 146, 151);
}
.product-content-right {
  width: 50%;
}
.product-content-right img {
  margin-top: 45px;
  width: 100%;
}
.product-content-box {
  width: 1500px;
  margin: auto;
  overflow: hidden;
}
.product-one,
.product-two,
.product-three {
  /* margin-top: 50px; */
  display: flex;
  padding: 50px 64px;
}
/* .product-three {
  padding-bottom: 100px;
} */
.text-one {
  font-family: '微软雅黑';
  font-weight: 410;
  font-style: normal;
  font-size: 48px;
  color: #495362;
}
.text-two {
  margin-top: 10px;
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 28px;
  color: #495362;
  line-height: 50px;
}
.product-one-left, .product-one-right {
  width: 50%;
}
.product-three-left {
  width: 50%;
  padding-right: 60px;
}
.product-one-right img {
  margin-left: 52px;
}
.product-two-left,
.product-two-right {
  width: 50%;
}
.product-two-right {
  margin-left: 152px;
}
.product-two-left img {
  /* margin-left: 52px; */
  width: 100%;
}
.product-three-right img {
}
</style>
<style media="screen">
/*分辨率低于1280，采用下面的样式*/
@media screen and (max-device-width: 1500px) {
  .product-content,
  .product-content-box {
    width: 1200px !important;
  }
  .product-content-two {
    font-size: 36px !important;
  }
  .product-content-right {
    margin-left: 60px !important;
  }
  .product-content-four {
    font-size: 16px !important;
  }
  .text-one {
    font-size: 36px !important;
  }
  .product-one-right img {
    /* width: 600px !important; */
    margin-left: 50px !important;
  }
  .text-two {
    font-size: 20px !important;
  }
  .product-content-three {
    font-size: 48px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/product.vue